export default __webpack_public_path__ + "static/media/reveal.2f51674e.svg";